/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Save_Title_HintInputs */

const en_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save current settings as a preset`)
};

const fr_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les paramètres actuels comme préréglage`)
};

const de_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Einstellungen als Voreinstellung speichern`)
};

const it_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva le impostazioni correnti come predefinite`)
};

const ru_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраните текущие настройки как предустановку.`)
};

const es_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar la configuración actual como un ajuste preestablecido`)
};

const zh_cn2_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将当前设置保存为预设`)
};

const ja_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の設定をプリセットとして保存する`)
};

const hi_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान सेटिंग्स को प्रीसेट के रूप में सहेजें`)
};

const pt_pt2_audio_description_export_preset_save_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Save_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar as configurações atuais como uma predefinição`)
};

/**
* | output |
* | --- |
* | "Save current settings as a preset" |
*
* @param {Audio_Description_Export_Preset_Save_Title_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_save_title_hint = /** @type {((inputs?: Audio_Description_Export_Preset_Save_Title_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Save_Title_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_save_title_hint(inputs)
	if (locale === "de") return de_audio_description_export_preset_save_title_hint(inputs)
	if (locale === "it") return it_audio_description_export_preset_save_title_hint(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_save_title_hint(inputs)
	if (locale === "es") return es_audio_description_export_preset_save_title_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_save_title_hint(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_save_title_hint(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_save_title_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_save_title_hint(inputs)
	return en_audio_description_export_preset_save_title_hint(inputs)
});